import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { TAIGA_UI_MODULES } from 'app/@taiga-modules';

@Component({
  selector: 'app-prices',
  standalone: true,
  imports: [
    CommonModule,
    ...TAIGA_UI_MODULES,
    RouterOutlet,
  ],
  templateUrl: './prices.component.html',
  styleUrl: './prices.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PricesComponent {

  store$ = inject(Store);
  otaDetails: boolean = false;
  
}
